import React from "react";
import { ArrowBackCircle } from 'react-ionicons'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import { Modal } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import constantURI from "../URI"
import _post from "../Functions/Post"
import stylesMed from "./stylesMed"
import SearchFilterFunction from "../Functions/SearchFilter"
import ReactSpinnerTimer from "react-spinner-timer";
import Authenticate from "../Functions/MedRepAuthenticate"

export default class AddVisit extends React.Component {

    constructor() {
        super();
        this.state = {
            objective: "", feedback: "", request: "", doubleVisit: "", consumptionInput: "", tradeInput: "", offerInput: "", Date: new Date(),
            todaysDate: "", brandReminder: "", items: [], clientIndex: -1, sampleProductIndex: -1, marketProductIndex: -1, itemName: [], showSamples: false,
            showMarketing: false, showClients: false, showSampleProducts: false, showMarketProducts: false, code: [], codeMark: [], name: [], nameMark: [],
            qty: [], catalog: [], consumption: [], trade: [], offer: [], sampleIndex: 0, marketIndex: 0, disableDateIn: false, disableDateOut: false,
            disableDate: true, timeIn: "", timeOut: "", dateIn: "", dateOut: "", clients: [], products: [], loading: true, user: "", ITBD: "", HCP: "",
            disableClient: false, VisitID: 0, sampleIds: [], marketIds: [], VisitId: 0, visitsCount: 0, USVisits: [], USVisits2: [], USVisitsProd: [],
            USVisitsProd2: [], UUID: [], UUID2: [], visitsUpdateCount: 0, USUVisits: [], USUVisits2: [], USUVisitsProd: [], USUVisitsProd2: [], UUID3: [],
            UUID4: [], isPharm: false, USVisitsMark: [], USUVisitsMark: [], USVisitsMark2: [], USUVisitsMark2: [], itemIndexSample: 0, itemIndexMarket: 0,
            showAlertMarket: false, showAlertSample: false, disableSave: false, disableSync: false, preventSymbols: ["e", "E", "+", "-", "."],
            requiredFields: { HCP: false, dateIn: false, dateOut: false, items: false, objective: false, feedback: false }, showRequiredAlert: false,
            alertString: "", clientsCopy: [], longitudeIn: "", latitudeIn: "", addressDateIn: "", addressDateOut: "", longitudeOut: "", latitudeOut: "",
            showAlertBack: false, loading: false, token: "", feedbackMark: [], feedbackInput: "", showCall: false, specialRequest: "", coachDay: false,
            isSupervisor: false, rep: [], samplesLimit: 5, inStock: [], USVisitRequests: [], USVisitRequests2: [], show: true, showBrand: false, brandItems: [],
            remark: [], mainIndex: 0, showAlert: false, brandIndex: 0, brandItemsIds: [], USVisitBrands: [], USUVisitsBrands2: [], authenticate: false,
            SampleItems: [], MarketItems: [], alertUndefined: false
        }
    }

    async componentDidMount() {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        //this.setState({ todaysDate: this.state.Date.toISOString().substring(0, 10) });

        //this.setState({ ...this.state.requiredFields.dateIn = true });

        //const d = new Date();
        //d.setDate(d.getDate());
        //await this.setState({ dateIn: d.toISOString().substring(0, 10), timeIn: d.toISOString().substring(11, 19), disableDateIn: true });


        const clients = localStorage.getItem('HCPs');
        const user = localStorage.getItem('User');
        const HCP = localStorage.getItem('HCPDailySched');
        const id = localStorage.getItem('VisitID');
        const visitsCount = localStorage.getItem('UnsyncedVisitsCount');
        const usvisits = localStorage.getItem('UnsyncedVisits');
        const usvisitsprod = localStorage.getItem('UnsyncedVisitsProducts');
        const uuid = localStorage.getItem('UUID');
        const visitsUpdateCount = localStorage.getItem('UnsyncedVisitsCount2');
        const usvisits2 = localStorage.getItem('UnsyncedVisits2');
        const usvisitsprod2 = localStorage.getItem('UnsyncedVisitsProducts2');
        const usvisitsMark = localStorage.getItem('UnsyncedVisitsMark');
        const uuid2 = localStorage.getItem('UUID2');
        const usvisitsmark2 = localStorage.getItem('UnsyncedVisitsMark2');
        const token = localStorage.getItem('Token');
        const request = localStorage.getItem('Request');
        const coachDay = localStorage.getItem('CoachDay');
        const isSupervisor = localStorage.getItem('isSupervisor');
        const usvisitsRequests = localStorage.getItem('UnsyncedVisitsRequests');
        const usvisitsBrands = localStorage.getItem('UnsyncedVisitsBrands');
        const usvisitsBrands2 = localStorage.getItem('UnsyncedVisitsBrands2');
        await this.setState({
            clients: JSON.parse(clients), clientsCopy: JSON.parse(clients), user: JSON.parse(user), HCP: JSON.parse(HCP), VisitId: JSON.parse(id),
            visitsCount: JSON.parse(visitsCount), USVisits: JSON.parse(usvisits), USVisitsProd: JSON.parse(usvisitsprod),
            UUID: JSON.parse(uuid), visitsUpdateCount: JSON.parse(visitsUpdateCount), USUVisits: JSON.parse(usvisits2), USUVisitsProd: JSON.parse(usvisitsprod2),
            UUID3: JSON.parse(uuid2), USVisitsMark: JSON.parse(usvisitsMark), USUVisitsMark: JSON.parse(usvisitsmark2), token: JSON.parse(token),
            coachDay: JSON.parse(coachDay), specialRequest: JSON.parse(request), isSupervisor: JSON.parse(isSupervisor), USVisitBrands: JSON.parse(usvisitsBrands),
            USVisitBrands2: JSON.parse(usvisitsBrands2), USVisitRequests: JSON.parse(usvisitsRequests)
        });
        if (this.state.HCP !== "") {
            await this.setState({ loading: true });
            if (this.state.coachDay) {
                await this.setState({ ...this.state.requiredFields.items = true, ...this.state.requiredFields.objective = true, ...this.state.requiredFields.feedback = true });
            }
            this.state.clients.map(async (item, index) => {
                if (item.id === this.state.HCP) {
                    await this.setState({ clientIndex: index, disableDate: false, disableClient: true, ...this.state.requiredFields.HCP = true, loading: false });
                }
            })
            if (this.state.clients[this.state.clientIndex] !== undefined && this.state.clients[this.state.clientIndex].clienttype[1] === "Pharmacy") {
                this.setState({ isPharm: true });
            }
            this.showCall();
        }
        const productsURL = constantURI() + "odooController/MedRepRead";
        const stockBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "x_stock",
                args: [],
                kwargs: {
                    fields: ["x_product_id", "remaining_stock", "x_partner_id"],
                    domain: [["x_partner_id", "=", this.state.user]],
                    limit: 4,
                    offset: 0,
                    order: "create_date DESC"
                }
            },
            "token": this.state.token
        }
        const clientsBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "res.partner",
                args: [],
                kwargs: {
                    fields: ["name", "street", "phone", "potential", "cf", "state_id", "x_specialty_id", "clienttype", "x_month_visits", "x_city_id"],
                    domain: [["x_repuser", "=", this.state.user]]
                }
            },
            "token": this.state.token
        }
        const rep = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "res.partner",
                "args": [],
                "kwargs": {
                    "fields": ["name"],
                    "domain": [["name", "=", this.state.user]]
                }
            },
            "token": this.state.token
        }
        const productsBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "product.product",
                args: [],
                kwargs: {
                    fields: ["default_code", "name"]
                }
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(productsURL, productsBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ products: data.result })
                        localStorage.setItem('ProductsList', JSON.stringify(this.state.products));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(productsURL, rep).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        this.setState({ rep: data.result })
                        localStorage.setItem('UserDetail', JSON.stringify(this.state.rep));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(productsURL, clientsBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ clients: data.result, clientsCopy: data.result, clientWithFilter: data.result, loading: false })
                        localStorage.setItem('HCPs', JSON.stringify(this.state.clients));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(productsURL, stockBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ inStock: data.result, loading: false })
                        localStorage.setItem('Products', JSON.stringify(this.state.inStock));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const prods = localStorage.getItem('ProductsList');
            const rep = localStorage.getItem("UserDetail");
            const clients = localStorage.getItem('HCPs');
            const inStock = localStorage.getItem('Products');
            this.setState({ clients: JSON.parse(clients), clientsCopy: JSON.parse(clients), products: JSON.parse(prods), rep: JSON.parse(rep), inStock: JSON.parse(inStock), loading: false });
        }
    }

    onGoBack = () => {
        this.props.history.push("./LandingPageRep");
        localStorage.setItem('HCPDailySched', JSON.stringify(""));
        localStorage.setItem('Request', JSON.stringify(""));
    }

    onSearch = async (text) => {
        var values = await SearchFilterFunction(text, this.state.clients, this.state.clientsCopy, this.state.noData);
        this.setState({ clients: values.items, noData: values.noData })
    }

    onSelectItems = async (e) => {
        var itemsSelected = e.target.options;
        var values = [];
        var texts = [];
        for (var i = 0, l = itemsSelected.length; i < l; i++) {
            if (itemsSelected[i].selected) {
                values.push(itemsSelected[i].value);
                texts.push(itemsSelected[i].text);
            }
        }
        await this.setState({ items: values, itemName: texts });
        if (this.state.items.length === 0)
            this.setState({ ...this.state.requiredFields.items = false })
        else
            this.setState({ ...this.state.requiredFields.items = true })
    }

    onSelectClient = async (id) => {
        await this.setState({ clients: this.state.clientsCopy });
        await this.state.clientsCopy.map(async (item, index) => {
            if (id === item.id)
                await this.setState({ clientIndex: index, getButton: false });
        })
        if (this.state.clientIndex !== "-1" || this.state.clientIndex === -1) {
            this.setState({ disableDate: false, ...this.state.requiredFields.HCP = true });

            if (this.state.clients[this.state.clientIndex].clienttype[1] === "Pharmacy") {
                this.setState({ isPharm: true });
            }
        }
        else
            this.setState({ disableDate: true, ...this.state.requiredFields.HCP = false });
        this.closeClients();
        if (this.state.objective === "")
            this.showCall();
    }

    onSelectSampleProduct = async (e) => {
        await this.setState({ sampleProductIndex: e.target.value, ...this.state.SampleItems[this.state.sampleIndex] = {} });
        await this.setState({
            ...this.state.SampleItems[this.state.sampleIndex].code = this.state.products[this.state.sampleProductIndex].default_code,
            ...this.state.SampleItems[this.state.sampleIndex].id = this.state.products[this.state.sampleProductIndex].id,
            ...this.state.SampleItems[this.state.sampleIndex].name = this.state.products[this.state.sampleProductIndex].name
        });
        this.closeSampleProducts();
    }

    onSelectMarketProduct = async (e) => {
        await this.setState({ marketProductIndex: e.target.value, ...this.state.MarketItems[this.state.marketIndex] = {} });
        await this.setState({
            ...this.state.MarketItems[this.state.marketIndex].code = this.state.products[this.state.marketProductIndex].default_code,
            ...this.state.MarketItems[this.state.marketIndex].id = this.state.products[this.state.marketProductIndex].id,
            ...this.state.MarketItems[this.state.marketIndex].name = this.state.products[this.state.marketProductIndex].name
        });
        this.closeMarketProducts();
    }

    onChangeClient = (e) => {
        this.setState({ amount: e.target.value })
    }

    onChangeObjective = async (e) => {
        await this.setState({ objective: e.target.value })
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.objective = false })
        else
            this.setState({ ...this.state.requiredFields.objective = true })
    }

    onChangeFeedback = async (e) => {
        await this.setState({ feedback: e.target.value });
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.feedback = false })
        else
            this.setState({ ...this.state.requiredFields.feedback = true })
    }

    onChangeRequest = (e) => {
        this.setState({ request: e.target.value })
    }

    onChangeDoubleVisit = (e) => {
        this.setState({ doubleVisit: e.target.value })
    }

    onChangeQuantity = (index) => (e) => {
        this.state.inStock.map((item) => {
            if (item.x_product_id[0] === this.state.SampleItems[index].id) {
                if (Number(e.target.value) <= item.remaining_stock)
                    this.setState({ ...this.state.SampleItems[this.state.sampleIndex].qty = e.target.value });
                else {
                    var sampleItems = this.state.SampleItems;
                    sampleItems.splice(this.state.sampleIndex, 1);
                    this.setState({ SampleItems: sampleItems });
                    alert("Samples limit is " + item.remaining_stock);
                }
            }
        })
    }

    onChangeConsumption = (e) => {
        this.setState({ ...this.state.MarketItems[this.state.marketIndex].consumption = e.target.value })
    }

    onChangeTrade = (e) => {
        this.setState({ ...this.state.MarketItems[this.state.marketIndex].trade = e.target.value })
    }

    onChangeOffer = (e) => {
        this.setState({ ...this.state.MarketItems[this.state.marketIndex].offer = e.target.value })
    }

    onChangeFeedbackMark = (e) => {
        this.setState({ ...this.state.MarketItems[this.state.marketIndex].feedback = e.target.value })
    }

    onChangeBrandReminder = async (e) => {
        var itemsSelected = e.target.options;
        var values = [];
        for (var i = 0, l = itemsSelected.length; i < l; i++) {
            if (itemsSelected[i].selected) {
                values.push(itemsSelected[i].value);
            }
        }
        await this.setState({ brandReminder: values });
    }

    onAddSampleItem = () => {
        if (this.state.SampleItems[this.state.sampleIndex] !== undefined && this.state.SampleItems[this.state.sampleIndex].qty === undefined) {
            alert("Please fill the required fields!");
        }
        else {
            if (this.state.showSamples) {
                this.setState({ sampleIndex: this.state.sampleIndex + 1, sampleProductIndex: -1 });
            }
            this.state.code.length = this.state.sampleIndex + 1;
            this.setState(s => ({ showSamples: !s.showSamples }));
        }
    }

    onAddMarketItem = () => {
        if (this.state.MarketItems[this.state.marketIndex] !== undefined && (this.state.MarketItems[this.state.marketIndex].feedback === undefined || this.state.MarketItems[this.state.marketIndex].consumption === undefined || this.state.MarketItems[this.state.marketIndex].trade === 0 || this.state.MarketItems[this.state.marketIndex].offer === 0)) {
            alert("Please fill the required fields!");
        }
        else {
            if (this.state.showMarketing) {
                this.setState({ marketIndex: this.state.marketIndex + 1, marketProductIndex: -1 });
            }
            this.state.codeMark.length = this.state.marketIndex + 1;
            this.setState(s => ({ showMarketing: !s.showMarketing }));
        }
    }

    closeAlertDeleteSample = () => {
        this.setState({ showAlertSample: false })
    }

    showAlertDeleteSample = (itemIndexSample) => {
        this.setState({ showAlertSample: true, itemIndexSample: itemIndexSample });
    }

    onDeleteSampleItem = (index) => {
        var sampleItems = this.state.SampleItems;
        sampleItems.splice(index, 1);
        this.setState({ SampleItems: sampleItems });
    }

    onDeleteMarketItem = (index) => {
        var markItems = this.state.MarketItems;
        markItems.splice(index, 1);
        this.setState({ MarketItems: markItems });
    }

    closeAlertDeleteMarket = () => {
        this.setState({ showAlertMarket: false })
    }

    showAlertDeleteMarket = (itemIndexMarket) => {
        this.setState({ showAlertMarket: true, itemIndexMarket: itemIndexMarket });

    }

    DateIn = async () => {
        this.setState({ ...this.state.requiredFields.dateIn = true });
       
        const d = new Date();
        d.setDate(d.getDate());
        await this.setState({ dateIn: d.toISOString().substring(0, 10), timeIn: d.toISOString().substring(11, 19), disableDateIn: true });
    }

    DateOut = async () => {
        this.setState({ ...this.state.requiredFields.dateOut = true });
        //if (navigator.geolocation) {
        //    await navigator.geolocation.getCurrentPosition(async (position) => {
        //        await this.setState({ latitudeOut: position.coords.latitude, longitudeOut: position.coords.longitude });
        //        //await this.setState({ longitudeOut: this.props.coords.longitude, latitudeOut: this.props.coords.latitude });
        //        Geocode.setApiKey("AIzaSyAKWAPSaonhKOAocStUTci9IRysL7C2Ygs");
        //        Geocode.setLanguage("en");
        //        Geocode.setRegion("es");
        //        Geocode.setLocationType("ROOFTOP");
        //        await Geocode.fromLatLng(this.state.latitudeOut, this.state.longitudeOut).then(
        //            (response) => {
        //                //const address = response.results[0].formatted_address;
        //                const address = response.plus_code.compound_code;
        //                this.setState({ addressDateOut: address });
        //            })
        //    });
        //}
        const d = new Date();
        d.setDate(d.getDate());
        await this.setState({ dateOut: d.toISOString().substring(0, 10), timeOut: d.toISOString().substring(11, 19), disableDateOut: true });
    }

    closeClients = () => {
        this.setState({ showClients: false });
    }

    showClients = () => {
        this.setState({ showClients: true, clientIndex: -1 });
    }

    closeCall = () => {
        this.setState({ showCall: false });
    }

    showCall = () => {
        this.setState({ showCall: true });
    }

    closeSampleProducts = () => {
        this.setState({ showSampleProducts: false });
    }

    showSampleProducts = () => {
        this.setState({ showSampleProducts: true });
    }

    closeMarketProducts = () => {
        this.setState({ showMarketProducts: false });
    }

    showMarketProducts = () => {
        this.setState({ showMarketProducts: true });
    }

    onSync = async () => {
        await this.setState({ disableSync: true });
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });

        const createVisitURL = constantURI() + "OdooController/CreateVisit";
        const createVisitLinesURL = constantURI() + "odooController/CreateEventLines";
        const createCompetURL = constantURI() + "odooController/CreateCompetitor";
        const updateVisitURL = constantURI() + "odooController/UpdateVisit"

        if (this.state.HCP === "") {
            const visits = localStorage.getItem('UnsyncedVisits');
            const visitProduct = localStorage.getItem('UnsyncedVisitsProducts');
            const uuid = localStorage.getItem('UUID');
            const visitsMark = localStorage.getItem('UnsyncedVisitsMark');
            const visitsBrands = localStorage.getItem('UnsyncedVisitsBrands');
            const visitsRequests = localStorage.getItem('UnsyncedVisitsRequests');
            await this.setState({
                USVisits2: JSON.parse(visits), USVisitsProd2: JSON.parse(visitProduct), UUID2: JSON.parse(uuid),
                USVisitsMark2: JSON.parse(visitsMark), USVisitsRequests2: JSON.parse(visitsRequests), USUVisitBrands2: JSON.parse(visitsBrands)
            });
            this.state.USVisits2.map(async (item, index, arr) => {
                if (this.state.authenticate) {
                    await _post(createVisitURL, item).then((response) => {
                        return response.json().then(async (data) => {
                            if (data.result !== undefined) {
                                if (this.state.USVisitsProd2 !== null || this.state.USVisitsProd2 !== []) {
                                    await this.state.USVisitsProd2.map(async (item2, index2) => {
                                        if (item2.params.args[0].x_event_id === this.state.UUID2[index]) {
                                            await this.setState({ ...this.state.USVisitsProd2[index2].params.args[0].x_event_id = data.result })
                                            await _post(createVisitLinesURL, this.state.USVisitsProd2[index2])
                                        }
                                    })
                                }
                                if (this.state.USVisitsRequests2 !== null || this.state.USVisitsRequests2 !== []) {
                                    this.state.USVisitsRequests2.map(async (item4, index4) => {
                                        await _post(createCompetURL, this.state.USVisitsRequests2[index4]);
                                    })
                                }
                                if (this.state.USVisitsMark2 !== null || this.state.USVisitsMark2 !== []) {
                                    await this.state.USVisitsMark2.map(async (item3, index3) => {
                                        if (item3.params.args[0].event_id === this.state.UUID2[index]) {
                                            await this.setState({ ...this.state.USVisitsMark2[index3].params.args[0].event_id = data.result })
                                            await _post(createCompetURL, this.state.USVisitsMark2[index3])
                                        }
                                    })
                                }
                                if (this.state.USUVisitBrands2 !== null || this.state.USUVisitBrands2 !== []) {
                                    await this.state.USUVisitBrands2.map(async (item5, index5) => {
                                        if (item5.params.args[0].caldendar_event === this.state.UUID2[index]) {
                                            await this.setState({ ...this.state.USUVisitBrands2[index5].params.args[0].caldendar_event = data.result })
                                            await _post(createCompetURL, this.state.USUVisitBrands2[index5])
                                        }
                                    })
                                }
                                if (index === arr.length - 1) {
                                    await localStorage.setItem('UnsyncedVisitsCount', JSON.stringify(0));
                                    await localStorage.setItem('UnsyncedVisits', JSON.stringify([]));
                                    await localStorage.setItem('UnsyncedVisitsProducts', JSON.stringify([]));
                                    await localStorage.setItem('UnsyncedVisitsMark', JSON.stringify([]));
                                    await localStorage.setItem('UnsyncedVisitsBrands', JSON.stringify([]));
                                    await localStorage.setItem('UnsyncedVisitsRequests', JSON.stringify([]));
                                    localStorage.setItem('CoachDay', JSON.stringify(false));
                                    await localStorage.setItem('UUID', JSON.stringify([]));
                                    await alert("Synced Successfully");
                                    this.props.history.push("./LandingPageRep");
                                }
                            }
                            else {
                                this.setState({ alertUndefined: true });
                            }
                        })
                    })
                }
                else if (!this.state.authenticate && index === arr.length - 1) {
                    alert("Only sync when connected to the Internet!");
                    await this.setState({ disableSync: false });
                }
            })
        }
        else {
            const visits = localStorage.getItem('UnsyncedVisits2');
            const visitsProducts = localStorage.getItem('UnsyncedVisitsProducts2');
            const uuid = localStorage.getItem('UUID2');
            const visitsMarket = localStorage.getItem('UnsyncedVisitsMark2');
            const visitsBrands = localStorage.getItem('UnsyncedVisitsBrands2');
            const visitsRequests = localStorage.getItem('UnsyncedVisitsRequests');
            await this.setState({
                USUVisits2: JSON.parse(visits), USUVisitsProd2: JSON.parse(visitsProducts), UUID4: JSON.parse(uuid),
                USUVisitsMark2: JSON.parse(visitsMarket), USVisitsRequests2: JSON.parse(visitsRequests), USUVisitsBrands2: JSON.parse(visitsBrands),
            });
            this.state.USUVisits2.map(async (item, index, arr) => {
                if (this.state.authenticate) {
                    await _post(updateVisitURL, item).then((response) => {
                        return response.json().then(async (data) => {
                            if (this.state.USUVisitsProd2 !== null || this.state.USUVisitsProd2 !== []) {
                                await this.state.USUVisitsProd2.map(async (item2, index2) => {
                                    if (item2.params.args[0].x_event_id === this.state.UUID4[index]) {
                                        await this.setState({ ...this.state.USUVisitsProd2[index2].params.args[0].x_event_id = item.params.args[0][0] })
                                        await _post(createVisitLinesURL, this.state.USVisitsProd2[index2])
                                    }
                                })
                            }
                            if (this.state.USVisitsRequests2 !== null || this.state.USVisitsRequests2 !== []) {
                                this.state.USVisitsRequests2.map(async (item4, index4) => {
                                    await _post(createCompetURL, this.state.USVisitsRequests2[index4]);
                                })
                            }
                            if (this.state.USUVisitsMark2 !== null || this.state.USUVisitsMark2 !== []) {
                                await this.state.USUVisitsMark2.map(async (item3, index3) => {
                                    if (item3.params.args[0].event_id === this.state.UUID4[index]) {
                                        await this.setState({ ...this.state.USUVisitsMark2[index3].params.args[0].event_id = item.params.args[0][0] });
                                        await _post(createCompetURL, this.state.USVisitsMark2[index3])
                                    }
                                })
                            }
                            if (this.state.USUVisitsBrands2 !== null || this.state.USUVisitsBrands2 !== []) {
                                await this.state.USUVisitsBrands2.map(async (item5, index5) => {
                                    if (item5.params.args[0].caldendar_event === this.state.UUID4[index]) {
                                        await this.setState({ ...this.state.USUVisitsBrands2[index5].params.args[0].caldendar_event = item.params.args[0][0] });
                                        await _post(createCompetURL, this.state.USUVisitsBrands2[index5])
                                    }
                                })
                            }
                            if (index === arr.length - 1) {
                                await localStorage.setItem('HCPDailySched', JSON.stringify(""));
                                await localStorage.setItem('VisitID', JSON.stringify(0));
                                await localStorage.setItem('UnsyncedVisitsCount2', JSON.stringify(0));
                                await localStorage.setItem('UnsyncedVisits2', JSON.stringify([]));
                                await localStorage.setItem('UnsyncedVisitsProducts2', JSON.stringify([]));
                                await localStorage.setItem('UnsyncedVisitsMark2', JSON.stringify([]));
                                await localStorage.setItem('UnsyncedVisitsBrands2', JSON.stringify([]));
                                await localStorage.setItem('UnsyncedVisitsRequests', JSON.stringify([]));
                                await localStorage.setItem('UUID2', JSON.stringify([]));
                                localStorage.setItem('CoachDay', JSON.stringify(false));
                                await alert("Synced Successfully");
                                this.props.history.push("./LandingPageRep");
                            }
                        })
                    })
                }
                else if (!this.state.authenticate && index === arr.length - 1) {
                    alert("Only sync when connected to the Internet!");
                }
            })
        }
    }

    onSave = async () => {
        await this.setState({ disableSave: true });
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        var toFill = false;
        var alertString = "";
        Object.keys(this.state.requiredFields).map(async (item, index) => {
            if (!this.state.requiredFields[item]) {
                toFill = true;
                alertString += item + ", ";
                await this.setState({ alertString: alertString });
            }
        })

        if (toFill === true) {
            this.setState({ disableSave: false, showRequiredAlert: true });
        }
        else {
            await this.setState({ disableSave: true, showRequiredAlert: false });

            const createVisitURL = constantURI() + "odooController/CreateVisit";
            const createVisitLinesURL = constantURI() + "odooController/CreateEventLines";
            const createCompetURL = constantURI() + "odooController/CreateCompetitor";
            const updateVisitURL = constantURI() + "odooController/UpdateVisit"

            if (this.state.HCP === "") {
                var visits = (this.state.USVisits === null || this.state.USVisits === []) ? [] : this.state.USVisits;
                var visitProducts = (this.state.USVisitsProd === null || this.state.USVisitsProd === []) ? [] : this.state.USVisitsProd;
                var uuid = (this.state.UUID === null || this.state.UUID === []) ? [] : this.state.UUID;
                var visitMarket = (this.state.USVisitsMark === null || this.state.USVisitsMark === []) ? [] : this.state.USVisitsMark;
                var visitRequests = (this.state.USVisitRequests === null || this.state.USVisitRequests === []) ? [] : this.state.USVisitRequests;
                var visitBrands = (this.state.USVisitBrands === null || this.state.USVisitBrands === []) ? [] : this.state.USVisitBrands;

                var visitBody = {
                    "jsonrpc": "2.0",
                    "params": {
                        "method": "create",
                        "model": "calendar.event",
                        "args": [
                            {
                                "name": this.state.clients[this.state.clientIndex].name + "-" + this.state.clients[this.state.clientIndex].state_id[1] +
                                    " (" + this.state.user + ")",
                                "start": this.state.dateIn,
                                "start_date": this.state.dateIn,
                                "start_datetime": this.state.dateIn + " " + this.state.timeIn,
                                "stop": this.state.dateOut,
                                "stop_date": this.state.dateOut,
                                "stop_datetime": this.state.dateOut + " " + this.state.timeOut,
                                "x_fbclient": this.state.feedback,
                                "x_purpose": this.state.objective,
                                "x_status": "1",
                                "x_fbvisit": this.state.itemName.join("-"),
                                "x_fbgeneral": this.state.request,
                                "brandreminder": this.state.checkReminder,
                                "partner_ids": [this.state.clients[this.state.clientIndex].id, this.state.rep[0].id]
                            }
                        ],
                        "kwargs": {}
                    },
                    "token": this.state.token
                }
                if (this.state.authenticate) {
                    await _post(createVisitURL, visitBody).then((response) => {
                        return response.json().then(async (data) => {
                            if (data.result !== undefined) {
                                await this.setState({ VisitID: data.result });
                                await this.state.SampleItems.forEach(async (item, index, arr) => {
                                    var visitSampleBody = {
                                        jsonrpc: "2.0",
                                        params: {
                                            method: "create",
                                            model: "x_calendar.event.lines",
                                            args: [
                                                {
                                                    "x_event_id": this.state.VisitID,
                                                    "x_product_id": item.id,
                                                    "x_quantity": item.qty
                                                }
                                            ],
                                            "kwargs": {}
                                        },
                                        "token": this.state.token
                                    }
                                    await _post(createVisitLinesURL, visitSampleBody).then(() => {
                                        this.state.inStock.map(async (product) => {
                                            if (item === product.x_product_id[0]) {
                                                var inStockBody = {
                                                    "jsonrpc": "2.0",
                                                    "params": {
                                                        "method": "write",
                                                        "model": "x_stock",
                                                        "args": [[product.id], {
                                                            "remaining_stock": product.remaining_stock - this.state.qty[index]
                                                        }
                                                        ],
                                                        "kwargs": {}
                                                    },
                                                    "token": this.state.token
                                                }
                                                await _post(createVisitLinesURL, inStockBody)
                                            }
                                        })
                                        if (!this.state.isPharm && index === arr.length - 1) {
                                            localStorage.setItem('HCPDailySched', JSON.stringify(""));
                                            localStorage.setItem('VisitID', JSON.stringify(0));
                                            this.props.history.push("./LandingPageRep");
                                        }
                                    })
                                })
                                await this.state.MarketItems.forEach(async (item2, index2, arr2) => {
                                    var visitMarketBody = {
                                        "jsonrpc": "2.0",
                                        "params": {
                                            "method": "create",
                                            "model": "competitor",
                                            "args": [{
                                                "event_id": this.state.VisitID,
                                                "product_id": item2.id,
                                                "trade": item2.trade,
                                                "consumption": item2.consumption,
                                                "offer": item2.offer,
                                                "feedback": item2.feedback
                                            }],
                                            "kwargs": {
                                            }
                                        },
                                        "token": this.state.token
                                    }
                                    await _post(createCompetURL, visitMarketBody).then((response) => {
                                        return response.json().then((data) => {
                                            if (index2 === arr2.length - 1) {
                                                localStorage.setItem('HCPDailySched', JSON.stringify(""));
                                                localStorage.setItem('VisitID', JSON.stringify(0));
                                                this.props.history.push("./LandingPageRep");
                                            }
                                        })
                                    })
                                })
                                await this.state.brandItemsIds.forEach(async (item3, index3, arr3) => {
                                    var visitBrandBody = {
                                        "jsonrpc": "2.0",
                                        "params": {
                                            "method": "create",
                                            "model": "brandreminderlist",
                                            "args": [{
                                                "caldendar_event": this.state.VisitID,
                                                "x_product_id": Number(item3),
                                                "remark": this.state.remark[index3]
                                            }],
                                            "kwargs": {
                                            }
                                        },
                                        "token": this.state.token
                                    }
                                    await _post(createCompetURL, visitBrandBody).then((response) => {
                                        return response.json().then((data) => {
                                            if (index3 === arr3.length - 1) {
                                                localStorage.setItem('HCPDailySched', JSON.stringify(""));
                                                localStorage.setItem('VisitID', JSON.stringify(0));
                                                this.props.history.push("./LandingPageRep");
                                            }
                                        })
                                    })
                                })
                                if (this.state.MarketItems.length === 0 && this.state.SampleItems.length === 0 && this.state.brandItemsIds.length === 0) {
                                    this.props.history.push("./LandingPageRep");
                                }
                            }
                            else {
                                this.setState({ alertUndefined: true });
                            }
                        })
                    })
                }
                else {
                    await visits.push(visitBody);
                    await this.setState({ visitsCount: this.state.visitsCount + 1 });
                    await localStorage.setItem('UnsyncedVisitsCount', JSON.stringify(this.state.visitsCount));
                    await localStorage.setItem('UnsyncedVisits', JSON.stringify(visits));

                    var test = uuidv4();
                    await uuid.push(test);
                    localStorage.setItem('UUID', JSON.stringify(uuid));

                    await this.state.brandItemsIds.forEach(async (item3, index3, arr3) => {
                        var visitBrandBody = {
                            "jsonrpc": "2.0",
                            "params": {
                                "method": "create",
                                "model": "brandreminderlist",
                                "args": [{
                                    "caldendar_event": test,
                                    "x_product_id": Number(item3),
                                    "remark": this.state.remark[index3]
                                }],
                                "kwargs": {
                                }
                            },
                            "token": this.state.token
                        }
                        await visitBrands.push(visitBrandBody);
                        if (index3 === arr3.length - 1) {
                            await localStorage.setItem('UnsyncedVisitsBrands', JSON.stringify(visitBrands));
                            if (this.state.brandItemsIds.length === 0) {
                                await alert("This Visit is not uploaded to Odoo due to internet disconnection. Sync when reconnected.");
                                this.props.history.push("./LandingPageRep");
                            }
                        }
                    })
                    await this.state.MarketItems.forEach(async (item2, index2, arr2) => {
                        var visitMarketBody = {
                            "jsonrpc": "2.0",
                            "params": {
                                "method": "create",
                                "model": "competitor",
                                "args": [{
                                    "event_id": test,
                                    "product_id": item2.id,
                                    "trade": item2.trade,
                                    "consumption": item2.consumption,
                                    "offer": item2.offer,
                                    "feedback": item2.feedback
                                }],
                                "kwargs": {
                                }
                            },
                            "token": this.state.token
                        }
                        await visitMarket.push(visitMarketBody);
                        if (index2 === arr2.length - 1) {
                            await localStorage.setItem('UnsyncedVisitsMark', JSON.stringify(visitMarket));
                            if (this.state.SampleItems.length === 0) {
                                await alert("This Visit is not uploaded to Odoo due to internet disconnection. Sync when reconnected.");
                                this.props.history.push("./LandingPageRep");
                            }
                        }
                    })
                    await this.state.SampleItems.forEach(async (item, index, arr) => {
                        var visitSampleBody = {
                            jsonrpc: "2.0",
                            params: {
                                method: "create",
                                model: "x_calendar.event.lines",
                                args: [
                                    {
                                        "x_event_id": test,
                                        "x_product_id": item.id,
                                        "x_quantity": item.qty
                                    }
                                ],
                                "kwargs": {}
                            },
                            "token": this.state.token
                        }
                        await visitProducts.push(visitSampleBody);
                        this.state.inStock.map(async (product) => {
                            if (item === product.x_product_id[0]) {
                                var inStockBody = {
                                    "jsonrpc": "2.0",
                                    "params": {
                                        "method": "write",
                                        "model": "x_stock",
                                        "args": [[product.id], {
                                            "remaining_stock": product.remaining_stock - this.state.qty[index]
                                        }
                                        ],
                                        "kwargs": {}
                                    },
                                    "token": this.state.token
                                }
                                await visitRequests.push(inStockBody);
                            }
                        })
                        if (index === arr.length - 1) {
                            await localStorage.setItem('UnsyncedVisitsProducts', JSON.stringify(visitProducts));
                            await localStorage.setItem('UnsyncedVisitsRequests', JSON.stringify(visitRequests));
                            await alert("This Visit is not uploaded to Odoo due to internet disconnection. Sync when reconnected.");
                            this.props.history.push("./LandingPageRep");
                        }
                    })
                    if (this.state.MarketItems.length === 0 && this.state.SampleItems.length === 0) {
                        await alert("This Visit is not uploaded to Odoo due to internet disconnection. Sync when reconnected.");
                        this.props.history.push("./LandingPageRep");
                    }
                }
            }
            else {
                var visitsUpdate = (this.state.USUVisits === null || this.state.USUVisits === []) ? [] : this.state.USUVisits;
                var visitProductUpdate = (this.state.USUVisitsProd === null || this.state.USUVisitsProd === []) ? [] : this.state.USUVisitsProd;
                var uuidUpdate = (this.state.UUID3 === null || this.state.UUID3 === []) ? [] : this.state.UUID3;
                var visitMarketUpdate = (this.state.USUVisitsMark === null || this.state.USUVisitsMark === []) ? [] : this.state.USUVisitsMark;
                var visitRequests = (this.state.USVisitRequests === null || this.state.USVisitRequests === []) ? [] : this.state.USVisitRequests;
                var visitBrandUpdate = (this.state.USVisitBrands === null || this.state.USVisitBrands === []) ? [] : this.state.USVisitBrands;

                if (this.state.coachDay) {
                    var visitBodyUpdate = {
                        jsonrpc: "2.0",
                        params: {
                            method: "write",
                            model: "calendar.event",
                            args: [[this.state.VisitId], {
                                "supdatein": this.state.dateIn,
                                "supdateout": this.state.dateOut,
                            }
                            ],
                            "kwargs": {}
                        },
                        "token": this.state.token
                    }
                    if (this.state.authenticate) {
                        await _post(updateVisitURL, visitBodyUpdate).then((response) => {
                            return response.json().then(async (data) => {
                                if (data.result !== undefined) {
                                    await this.setState({ VisitID: data.result });
                                    localStorage.setItem('HCPDailySched', JSON.stringify(""));
                                    localStorage.setItem('VisitID', JSON.stringify(0));
                                    localStorage.setItem('Request', JSON.stringify(""));
                                    localStorage.setItem('CoachDay', JSON.stringify(false));
                                    this.props.history.push("./LandingPageRep");
                                }
                                else {
                                    this.setState({ alertUndefined: true });
                                }
                            })
                        })
                    }
                    else {
                        await visitsUpdate.push(visitBodyUpdate);
                        await this.setState({ visitsUpdateCount: this.state.visitsUpdateCount + 1 });
                        await localStorage.setItem('UnsyncedVisitsCount2', JSON.stringify(this.state.visitsUpdateCount));
                        await localStorage.setItem('UnsyncedVisits2', JSON.stringify(visitsUpdate));
                    }
                }
                else {
                    var visitBodyUpdate = {
                        jsonrpc: "2.0",
                        params: {
                            method: "write",
                            model: "calendar.event",
                            args: [[this.state.VisitId], {
                                "start": this.state.dateIn,
                                "start_date": this.state.dateIn,
                                "start_datetime": this.state.dateIn + " " + this.state.timeIn,
                                "stop": this.state.dateOut,
                                "stop_date": this.state.dateOut,
                                "stop_datetime": this.state.dateOut + " " + this.state.timeOut,
                                "x_fbclient": this.state.feedback,
                                "x_purpose": this.state.objective,
                                "x_status": "1",
                                "x_fbvisit": this.state.itemName.join("-"),
                                "x_fbgeneral": this.state.request,
                                "brandreminder": this.state.checkReminder,
                            }
                            ],
                            "kwargs": {}
                        },
                        "token": this.state.token
                    }
                    if (this.state.authenticate) {
                        await _post(updateVisitURL, visitBodyUpdate).then((response) => {
                            return response.json().then(async (data) => {
                                if (data.result !== undefined) {
                                    await this.setState({ VisitID: data.result });
                                    this.state.SampleItems.forEach(async (item, index, arr) => {
                                        var visitSampleBody = {
                                            jsonrpc: "2.0",
                                            params: {
                                                method: "create",
                                                model: "x_calendar.event.lines",
                                                args: [
                                                    {
                                                        "x_event_id": this.state.VisitId,
                                                        "x_product_id": item.id,
                                                        "x_quantity": item.qty
                                                    }
                                                ],
                                                "kwargs": {}
                                            },
                                            "token": this.state.token
                                        }
                                        await _post(createVisitLinesURL, visitSampleBody).then(() => {
                                            this.state.inStock.map(async (product) => {
                                                if (item === product.x_product_id[0]) {
                                                    var inStockBody = {
                                                        "jsonrpc": "2.0",
                                                        "params": {
                                                            "method": "write",
                                                            "model": "x_stock",
                                                            "args": [[product.id], {
                                                                "remaining_stock": product.remaining_stock - this.state.qty[index]
                                                            }
                                                            ],
                                                            "kwargs": {}
                                                        },
                                                        "token": this.state.token
                                                    }
                                                    console.log(JSON.stringify(inStockBody));
                                                    await _post(createVisitLinesURL, inStockBody)
                                                }
                                            })
                                            if (!this.state.isPharm && index === arr.length - 1) {
                                                localStorage.setItem('HCPDailySched', JSON.stringify(""));
                                                localStorage.setItem('VisitID', JSON.stringify(0));
                                                localStorage.setItem('Request', JSON.stringify(""));
                                                this.props.history.push("./LandingPageRep");
                                            }
                                        })
                                    })
                                    await this.state.MarketItems.forEach(async (item2, index2, arr2) => {
                                        var visitMerketBody = {
                                            "jsonrpc": "2.0",
                                            "params": {
                                                "method": "create",
                                                "model": "competitor",
                                                "args": [{
                                                    "event_id": this.state.VisitId,
                                                    "product_id ": item2.id,
                                                    "trade": item2.trade,
                                                    "consumption": item2.consumption,
                                                    "offer": item2.offer,
                                                    "feedback": item2.feedback
                                                }],
                                                "kwargs": {
                                                }
                                            },
                                            "token": this.state.token
                                        }
                                        await _post(createCompetURL, visitMerketBody).then((response) => {
                                            return response.json().then((data) => {
                                                if (index2 === arr2.length - 1) {
                                                    localStorage.setItem('HCPDailySched', JSON.stringify(""));
                                                    localStorage.setItem('VisitID', JSON.stringify(0));
                                                    localStorage.setItem('Request', JSON.stringify(""));
                                                    this.props.history.push("./LandingPageRep");
                                                }
                                            })
                                        })
                                    })
                                    await this.state.brandItemsIds.forEach(async (item3, index3, arr3) => {
                                        var visitBrandBody = {
                                            "jsonrpc": "2.0",
                                            "params": {
                                                "method": "create",
                                                "model": "brandreminderlist",
                                                "args": [{
                                                    "caldendar_event": this.state.VisitId,
                                                    "x_product_id": Number(item3),
                                                    "remark": this.state.remark[index3]
                                                }],
                                                "kwargs": {
                                                }
                                            },
                                            "token": this.state.token
                                        }
                                        await _post(createCompetURL, visitBrandBody).then((response) => {
                                            return response.json().then((data) => {
                                                if (index3 === arr3.length - 1) {
                                                    localStorage.setItem('HCPDailySched', JSON.stringify(""));
                                                    localStorage.setItem('VisitID', JSON.stringify(0));
                                                    localStorage.setItem('Request', JSON.stringify(""));
                                                    this.props.history.push("./LandingPageRep");
                                                }
                                            })
                                        })
                                    })
                                    if (this.state.SampleItems.length === 0 && this.state.MarketItems.length === 0 && this.state.brandItemsIds.length === 0) {
                                        localStorage.setItem('HCPDailySched', JSON.stringify(""));
                                        localStorage.setItem('VisitID', JSON.stringify(0));
                                        localStorage.setItem('Request', JSON.stringify(""));
                                        this.props.history.push("./LandingPageRep");
                                    }
                                }
                                else {
                                    this.setState({ alertUndefined: true });
                                }
                            })
                        })
                    }
                    else {
                        await visitsUpdate.push(visitBodyUpdate);
                        await this.setState({ visitsUpdateCount: this.state.visitsUpdateCount + 1 });
                        await localStorage.setItem('UnsyncedVisitsCount2', JSON.stringify(this.state.visitsUpdateCount));
                        await localStorage.setItem('UnsyncedVisits2', JSON.stringify(visitsUpdate));
                        await localStorage.setItem('HCPDailySched', JSON.stringify(""));

                        var test2 = uuidv4();
                        await uuidUpdate.push(test2);
                        localStorage.setItem('UUID2', JSON.stringify(uuidUpdate));

                        await this.state.MarketItems.forEach(async (item2, index2, arr2) => {
                            var visitMerketBody = {
                                "jsonrpc": "2.0",
                                "params": {
                                    "method": "create",
                                    "model": "competitor",
                                    "args": [{
                                        "event_id": test2,
                                        "product_id": item2,
                                        "trade": item2.trade,
                                        "consumption": item2.consumption,
                                        "offer": item2.offer,
                                        "feedback": item2.feedback
                                    }],
                                    "kwargs": {
                                    }
                                },
                                "token": this.state.token
                            }
                            await visitMarketUpdate.push(visitMerketBody);
                            if (index2 === arr2.length - 1) {
                                await localStorage.setItem('UnsyncedVisitsMark2', JSON.stringify(visitMarketUpdate));
                                localStorage.setItem('Request', JSON.stringify(""));
                                if (this.state.SampleItems.length === 0 && this.state.brandItemsIds.length === 0) {
                                    await alert("This Visit is not uploaded to Odoo due to internet disconnection. Sync when reconnected.");
                                    this.props.history.push("./LandingPageRep");
                                }
                            }
                        })
                        await this.state.brandItemsIds.forEach(async (item3, index3, arr3) => {
                            var visitBrandBody = {
                                "jsonrpc": "2.0",
                                "params": {
                                    "method": "create",
                                    "model": "brandreminderlist",
                                    "args": [{
                                        "caldendar_event": test2,
                                        "x_product_id": Number(item3),
                                        "remark": this.state.remark[index3]
                                    }],
                                    "kwargs": {
                                    }
                                },
                                "token": this.state.token
                            }
                            await visitBrandUpdate.push(visitBrandBody);
                            if (index3 === arr3.length - 1) {
                                await localStorage.setItem('UnsyncedVisitsBrands2', JSON.stringify(visitBrandUpdate));
                                localStorage.setItem('Request', JSON.stringify(""));
                                if (this.state.SampleItems.length === 0) {
                                    await alert("This Visit is not uploaded to Odoo due to internet disconnection. Sync when reconnected.");
                                    this.props.history.push("./LandingPageRep");
                                }
                            }
                        })
                        await this.state.SampleItems.forEach(async (item, index, arr) => {
                            var visitSampleBody = {
                                jsonrpc: "2.0",
                                params: {
                                    method: "create",
                                    model: "x_calendar.event.lines",
                                    args: [
                                        {
                                            "x_event_id": test2,
                                            "x_product_id": item.id,
                                            "x_quantity": item.qty
                                        }
                                    ],
                                    "kwargs": {}
                                },
                                "token": this.state.token
                            }
                            await visitProductUpdate.push(visitSampleBody);
                            this.state.inStock.map(async (product) => {
                                if (item === product.x_product_id[0]) {
                                    var inStockBody = {
                                        "jsonrpc": "2.0",
                                        "params": {
                                            "method": "write",
                                            "model": "x_stock",
                                            "args": [[product.id], {
                                                "remaining_stock": product.remaining_stock - this.state.qty[index]
                                            }
                                            ],
                                            "kwargs": {}
                                        },
                                        "token": this.state.token
                                    }
                                    await visitRequests.push(inStockBody);
                                }
                            })
                            if (index === arr.length - 1) {
                                await localStorage.setItem('UnsyncedVisitsProducts2', JSON.stringify(visitProductUpdate));
                                await localStorage.setItem('UnsyncedVisitsRequests', JSON.stringify(visitRequests));
                                localStorage.setItem('Request', JSON.stringify(""));
                                await alert("This Visit is not uploaded to Odoo due to internet disconnection. Sync when reconnected.");
                                this.props.history.push("./LandingPageRep");
                            }
                        })
                    }
                }
            }
        }
    }

    closeAlertBack = () => {
        this.setState({ showAlertBack: false });
    }

    showAlertBack = () => {
        this.setState({ showAlertBack: true });
    }

    handleChange = (lap) => {
        if (lap.isFinish)
            console.log("Please connect to the internet!");
    }

    onAddBrandBool = () => {
        this.setState({ showBrand: true, show: false });
    }

    onChangeBrand = (e) => {
        this.setState({
            ...this.state.brandItems[this.state.mainIndex] = e.target.selectedOptions[0].text,
            ...this.state.brandItemsIds[this.state.mainIndex] = e.target.value,
        })

    }

    onChangeRemark = (e) => {
        this.setState({ ...this.state.remark[this.state.mainIndex] = e.target.value })
    }

    closeAlertDelete = () => {
        this.setState({ showAlert: false });
    }

    showAlertDelete = (brandIndex) => {
        this.setState({ showAlert: true, brandIndex: brandIndex });
    }

    onDeleteItem = (index) => {
        var remark = this.state.remark;
        remark.splice(index, 1);
        this.setState({ remark: remark });
        var brandItems = this.state.brandItems;
        brandItems.splice(index, 1);
        this.setState({ brandItems: brandItems });
    }

    onAddBrand = () => {
        if (this.state.showBrand) {
            this.setState({ mainIndex: this.state.mainIndex + 1 });
        }
        this.state.remark.length = this.state.mainIndex + 1;
        this.setState(s => ({ showBrand: !s.showBrand }));
    }

    render() {
        return (
            <div className="container-fluid vh-100" style={stylesMed.mainBackgroundColor}>
                {(this.state.HCP === "") ?
                    (this.state.visitsCount === 0 || this.state.visitsCount === null) ?
                        <div className="alert alert-secondary">You have 0 visits to sync with Odoo.</div> :
                        <div className="col alert alert-danger">You have {this.state.visitsCount} visits to sync with Odoo.
                          <div className="row">
                                <h5 className="col-sm-8">Only sync when connected to the Internet!</h5>
                                <div className="col-sm-4 d-flex flex-row-reverse">
                                    <div className="btn" style={stylesMed.wideButton} onClick={this.onSync}>Sync Planned Visits</div>
                                </div>
                            </div>
                        </div> :
                    (this.state.visitsUpdateCount === 0 || this.state.visitsUpdateCount === null) ?
                        <div className="alert alert-secondary">You have 0 visits to sync with Odoo.</div> :
                        <div className="col alert alert-danger">You have {this.state.visitsUpdateCount} visits to sync with Odoo.
                          <div className="row">
                                <h5 className="col-sm-8">Only sync when connected to the Internet!</h5>
                                <div className="col-sm-4 d-flex flex-row-reverse">
                                    <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton}
                                        onClick={this.onSync}>Sync Planned Visits</div>
                                </div>
                            </div>
                        </div>
                }
                {(!this.state.showRequiredAlert) ?
                    null :
                    <div className="col alert alert-danger">{this.state.alertString} are required fields that should be filled.</div>
                }
                {(!this.state.alertUndefined) ?
                    null :
                    <div className="col alert alert-danger">
                        <div className="row">
                            <h6 className="col-sm-8">There seems to be a problem.</h6>
                            <div className="col d-flex flex-row-reverse">
                                <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={() => window.location.reload()}>
                                    Reload</div>
                            </div>
                        </div>
                    </div>
                }
                <div className="row pt-3">
                    <div className="col">
                        <ArrowBackCircle className="btn" onClick={() => this.showAlertBack()} color={'#00bfff'} height="50px" width="50px" />
                    </div>
                    <div className="col text-center"><h5 style={stylesMed.visitTitle}>Visit: {new Date(this.state.todaysDate).toDateString()}</h5></div>
                    <div className="col d-flex flex-row-reverse">
                        <div className={(this.state.disableSave) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={this.onSave}>Save Visit</div>
                    </div>
                </div>
                <Modal show={this.state.showAlertBack} onHide={this.closeAlertBack} animation={false}>
                    <Modal.Header>
                        <Modal.Title>Save changes?</Modal.Title>
                    </Modal.Header>
                    <Modal.Footer>
                        <div className="btn" data-toggle="modal" data-target="#myModal" style={stylesMed.wideButton} onClick={this.onSave}>Save</div>
                        <div className="btn btn-secondary" data-toggle="modal" data-target="#myModal" style={stylesMed.cancelWideButton}
                            onClick={() => this.onGoBack()}>Discard</div>
                    </Modal.Footer>
                </Modal>
                <div className="mt-4 p-3" style={stylesMed.cardBackgroundColor}>
                    <div className="row">
                        <div className="col form-group ">
                            <label>*HCP:</label>
                            <input className={(this.state.disableClient) ? "form-control disabled" : "form-control"}
                                defaultValue={(this.state.loading || this.state.clientIndex === "-1" || this.state.clientIndex === -1) ? "" :
                                    this.state.clients[this.state.clientIndex].name}
                                onClick={(this.state.disableClient) ? null : this.showClients} style={(this.state.showRequiredAlert && !this.state.requiredFields.HCP) ?
                                    stylesMed.reportClientInputRequired : stylesMed.reportClientInput} />
                        </div>
                        <div className="col form-group">
                            <label>Code</label>
                            <p>{(this.state.loading || this.state.clientIndex === -1 || this.state.clientIndex === "-1") ? null : "CL-" +
                                this.state.clients[this.state.clientIndex].id}</p>
                        </div>
                        <div className="col form-group">
                            <label>Address</label>
                            <p>{(this.state.loading || this.state.clientIndex === -1 || this.state.clientIndex === "-1") ? null :
                                this.state.clients[this.state.clientIndex].street}</p>
                        </div>
                    </div>
                    <Modal show={this.state.showClients} onHide={this.closeClients} animation={false}>
                        <Modal.Header>
                            <Modal.Title>Select Client</Modal.Title>
                        </Modal.Header>
                        <Modal.Body><div>
                            <input type="text" className="form-control" placeholder="Search Here" onChange={text => this.onSearch(text)} />
                            {this.state.clients.map((item, index) => {
                                return (
                                    <div className="pt-3" key={index}>
                                        <div className="btn" onClick={() => this.onSelectClient(item.id)} >{item.name}</div>
                                    </div>
                                )
                            })}
                        </div></Modal.Body>
                    </Modal>
                    <Modal show={this.state.showCall} onHide={this.closeCall} animation={false}>
                        <Modal.Header>
                            <Modal.Title>Call Objective*: </Modal.Title>
                        </Modal.Header>
                        <Modal.Body><div>
                            <textarea className="form-control" value={this.state.objective} onChange={this.onChangeObjective}
                                style={(this.state.showRequiredAlert && !this.state.requiredFields.objective) ?
                                    stylesMed.reportClientInputRequired : stylesMed.reportClientInput} />
                            <div className="btn mt-2" style={stylesMed.deleteButtonAlert} onClick={() => this.closeCall()}>Ok</div>
                        </div></Modal.Body>
                    </Modal>
                    <div className="row mt-3 p-3">
                        <div className={(this.state.disableDateIn || this.state.disableDate) ? "col btn disabled" : "col btn"}
                            style={(this.state.showRequiredAlert && !this.state.requiredFields.dateIn) ?
                                stylesMed.wideButtonRequired : stylesMed.wideButton} onClick={this.DateIn}>Date In*</div>
                        <p className="col mt-3">{this.state.addressDateIn + " " + this.state.dateIn + " " + this.state.timeIn}</p>
                        <div className={(this.state.disableDateOut || !this.state.disableDateIn) ? "col btn disabled" : "col btn"}
                            style={(this.state.showRequiredAlert && !this.state.requiredFields.dateOut) ?
                                stylesMed.wideButtonRequired : stylesMed.wideButton} onClick={this.DateOut}>Date Out*</div>
                        <p className="col mt-3">{this.state.addressDateOut + " " + this.state.dateOut + " " + this.state.timeOut}</p>
                    </div>
                </div>
                {(this.state.loading)
                    ?
                    <div className="text-center">
                        <ReactSpinnerTimer
                            timeInSeconds={60}
                            totalLaps={60}
                            isRefresh={false}
                            onLapInteraction={this.handleChange}
                            isPause={false}
                        />
                    </div>
                    :
                    <div className={(this.state.coachDay && !this.state.isSupervisor) ? "invisible" : null}>
                        <div className="mt-4 p-3" style={stylesMed.cardBackgroundColor}>
                            <div className="row form-group">
                                <div className="col mt-1 form-group">
                                    <label>Call objective*:</label>
                                    <textarea className="form-control" value={this.state.objective} onChange={this.onChangeObjective}
                                        style={(this.state.showRequiredAlert && !this.state.requiredFields.objective) ?
                                            stylesMed.reportClientInputRequired : stylesMed.reportClientInput} />
                                </div>
                                <div className="col mt-1 form-group">
                                    <label>Client feedback*:</label>
                                    <textarea className="form-control" value={this.state.feedback} onChange={this.onChangeFeedback}
                                        style={(this.state.showRequiredAlert && !this.state.requiredFields.feedback) ?
                                            stylesMed.reportClientInputRequired : stylesMed.reportClientInput} />
                                </div>
                            </div>
                            <div className="row form-group">
                                <div className="col mt-1 form-group">
                                    <label>Special Request:</label>
                                    <textarea className="form-control" value={this.state.request} onChange={this.onChangeRequest}
                                        style={stylesMed.reportClientInput} />
                                </div>
                                <div className="col mt-1 form-group">
                                    <label>Brand Reminder: </label>
                                    <select className="col-sm-6 form-control" multiple id="sel1" value={this.state.brandReminder} onChange={this.onChangeBrandReminder}
                                        style={stylesMed.reportClientInput}>
                                        {this.state.products.map((item, index) => {
                                            return (
                                                <option key={index} value={item.id}>{item.name}</option>
                                            )
                                        })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row form-group">
                                <div className="col form-group">
                                    <label>Items to be detailed*:</label>
                                    <select className="col-sm-6 form-control" multiple id="sel1" value={this.state.items} onChange={this.onSelectItems}
                                        style={(this.state.showRequiredAlert && !this.state.requiredFields.items) ?
                                            stylesMed.reportClientInputRequired : stylesMed.reportClientInput}>
                                        {this.state.products.map((item, index) => {
                                            return (
                                                <option key={index} value={item.id}>{item.name}</option>
                                            )
                                        })
                                        }
                                    </select>
                                </div>
                                <div className="col mt-2 form-group">
                                    <label>Special Request to Deliver: {this.state.specialRequest}</label>
                                </div>
                                {/*<div className="col mt-1 form-group invisible">*/}
                                {/*    <label>Double Visit:</label>*/}
                                {/*    <select className="col-sm-6 form-control" id="sel1" value={this.state.doubleVisit} onChange={this.onChangeDoubleVisit}*/}
                                {/*        name="sellist1" style={stylesMed.reportClientInput}>*/}
                                {/*        <option value="">Coach</option>*/}
                                {/*        <option value="Abdul">Abdul Rahman Chebaro</option>*/}
                                {/*    </select>*/}
                                {/*</div>*/}
                            </div>
                        </div>


                        {/*<div className="mt-4 p-4" style={stylesMed.cardBackgroundColor}>*/}
                        {/*    <h3>Brand Reminder</h3>*/}
                        {/*    {*/}
                        {/*        (this.state.show) ?*/}
                        {/*            <div className="d-flex justify-content-center mt-3">*/}
                        {/*                <div className="btn" style={stylesMed.wideButton} onClick={this.onAddBrandBool}>Add Brand Item</div>*/}
                        {/*            </div> :*/}
                        {/*            (this.state.showBrand) ?*/}
                        {/*                <div>*/}
                        {/*                    {this.state.remark.map((item, index, arr) => {*/}
                        {/*                        if (index !== arr.length - 1) {*/}
                        {/*                            return (*/}
                        {/*                                <div className="row m-1" key={index}>*/}
                        {/*                                    <div className="col mt-1">*/}
                        {/*                                        <div className="btn" style={stylesMed.deleteButton} onClick={() => this.showAlertDelete(index)}>Delete</div>*/}
                        {/*                                    </div>*/}
                        {/*                                    <h6 className="col d-flex justify-content-center mt-1">{this.state.brandItems[index]}</h6>*/}
                        {/*                                    <h6 className="col d-flex justify-content-center mt-1">{this.state.remark[index]}</h6>*/}
                        {/*                                </div>*/}
                        {/*                            )*/}
                        {/*                        }*/}
                        {/*                        else return null*/}
                        {/*                    })}*/}
                        {/*                    <div className="row m-2">*/}
                        {/*                        <select className="col form-control" id="sel1" value={this.state.brandItemsIds[this.state.mainIndex]}*/}
                        {/*                            onChange={this.onChangeBrand} name="sellist1" >*/}
                        {/*                            <option value="">Items to be selected</option>*/}
                        {/*                            {this.state.products.map((item) => {*/}
                        {/*                                return (*/}
                        {/*                                    <option value={item.id}>{item.name}</option>*/}
                        {/*                                )*/}
                        {/*                            })*/}
                        {/*                            }*/}
                        {/*                        </select>*/}
                        {/*                        <input className="col form-control" placeholder="Remark"*/}
                        {/*                            value={(this.state.remark[this.state.mainIndex] === undefined) ? "" : this.state.remark[this.state.mainIndex]}*/}
                        {/*                            onChange={this.onChangeRemark} />*/}
                        {/*                    </div>*/}
                        {/*                </div> :*/}
                        {/*                this.state.remark.map((item, index, arr) => {*/}
                        {/*                    return (*/}
                        {/*                        <div className="row m-1" key={index}>*/}
                        {/*                            <div className="col mt-1">*/}
                        {/*                                <div className="btn" style={stylesMed.deleteButton} onClick={() => this.showAlertDelete(index)}>Delete</div>*/}
                        {/*                            </div>*/}
                        {/*                            <h6 className="col d-flex justify-content-center mt-1">{this.state.brandItems[index]}</h6>*/}
                        {/*                            <h6 className="col d-flex justify-content-center mt-1">{this.state.remark[index]}</h6>*/}
                        {/*                        </div>*/}
                        {/*                    )*/}
                        {/*                })*/}
                        {/*    }*/}
                        {/*    {*/}
                        {/*        (!this.state.show) ? <div className="d-flex justify-content-center mt-3">*/}
                        {/*            <div className="btn" style={stylesMed.wideButton} onClick={this.onAddBrand}>Add Brand Item</div>*/}
                        {/*        </div> : null*/}
                        {/*    }*/}
                        {/*</div>*/}
                        {/*<Modal show={this.state.showAlert} onHide={this.closeAlertDelete} animation={false}>*/}
                        {/*    <Modal.Header>*/}
                        {/*        <Modal.Title>Are you sure you want to delete this item?</Modal.Title>*/}
                        {/*    </Modal.Header>*/}
                        {/*    <Modal.Body><div>*/}
                        {/*        <div className="btn" style={stylesMed.deleteButtonAlert}*/}
                        {/*            onClick={() => { this.onDeleteItem(this.state.brandIndex); this.closeAlertDelete() }}>Delete</div>*/}
                        {/*        <div className="btn btn-secondary" style={stylesMed.cancelButtonAlert}*/}
                        {/*            onClick={() => this.closeAlertDelete()}>Cancel</div>*/}
                        {/*    </div></Modal.Body>*/}
                        {/*</Modal>*/}

                        <h3 className="mt-4">Samples</h3>
                        <div className="row m-1" style={stylesMed.visitTableHeader}>
                            <div className="col-sm-2 mt-1"></div>
                            <h6 className="col-sm-3 mt-1" style={stylesMed.reportTableItem}>*Code</h6>
                            <h6 className="col-sm-2 mt-1" style={stylesMed.reportTableItem}>*Name</h6>
                            <h6 className="col-sm-3 mt-1" style={stylesMed.reportTableItem}>*Quantity</h6>
                            <h6 className="col-sm-2 mt-1" style={stylesMed.reportTableItem}>Catalog</h6>
                        </div>
                        {(this.state.showSamples) ?
                            <div>
                                {
                                    this.state.SampleItems.map((item, index, arr) => {
                                        if (index !== arr.length - 1) {
                                            return (
                                                <div className="row m-1" key={index} style={stylesMed.visitTableStyle}>
                                                    <div className="col-sm-2 mt-1">
                                                        <div className="btn" style={stylesMed.deleteButton} onClick={() => this.showAlertDeleteSample(index)}>Delete</div>
                                                        <div className="btn" style={stylesMed.editButton} >Edit</div>
                                                    </div>
                                                    <h6 className="col-sm-3 mt-1">{item.code}</h6>
                                                    <h6 className="col-sm-2 mt-1">{item.name}</h6>
                                                    <h6 className="col-sm-3 mt-1">{item.qty}</h6>
                                                    <h6 className="col-sm-2 mt-1">{item.catalog}</h6>
                                                </div>
                                            )
                                        }
                                    })}
                                <div className="row m-1" style={stylesMed.visitTableStyle}>
                                    <div className="col-sm-2 mt-1"></div>
                                    <input className="col-sm-3 form-control"
                                        defaultValue={(this.state.loading || this.state.sampleProductIndex === -1) ?
                                            null : this.state.products[this.state.sampleProductIndex].default_code}
                                        onClick={this.showSampleProducts}
                                        style={stylesMed.visitProductCode} />
                                    <p className="col-sm-2 mt-1">{(this.state.loading || this.state.sampleProductIndex === -1) ? null :
                                        this.state.products[this.state.sampleProductIndex].name}</p>
                                    <input className="col-sm-3 form-control" type="number"
                                        onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                        value={this.state.qty[this.state.sampleIndex]}
                                        onChange={this.onChangeQuantity(this.state.sampleIndex)} style={stylesMed.visitProductCode} />
                                    <p className="col-sm-2 mt-1"></p>
                                </div>
                            </div> :
                            this.state.SampleItems.map((item, index, arr) => {
                                return (
                                    <div className="row m-1" key={index} style={stylesMed.visitTableStyle}>
                                        <div className="col-sm-2 mt-1">
                                            <div className="btn" style={stylesMed.deleteButton} onClick={() => this.showAlertDeleteSample(index)}>Deletee</div>
                                            <div className="btn" style={stylesMed.editButton} >Edit</div>
                                        </div>
                                       
                                        <h6 className="col-sm-3 mt-1">{item.code}</h6>
                                        <h6 className="col-sm-2 mt-1">{item.name}</h6>
                                        <h6 className="col-sm-3 mt-1">{item.qty}</h6>
                                        <h6 className="col-sm-2 mt-1">{item.catalog}</h6>
                                    </div>
                                )
                            })
                        }
                        <Modal show={this.state.showSampleProducts} onHide={this.closeSampleProducts} animation={false}>
                            <Modal.Header>
                                <Modal.Title>Select Product</Modal.Title>
                            </Modal.Header>
                            <Modal.Body><div>
                                <select className="col-sm-6 form-control" value={this.state.sampleProductIndex} onChange={this.onSelectSampleProduct}
                                    style={stylesMed.reportClientInput}>
                                    <option value=""></option>
                                    {this.state.products.map((item, index) => {
                                        return (
                                            <option key={index} value={index}>{item.name}</option>
                                        )
                                    })
                                    }
                                </select>
                            </div></Modal.Body>
                        </Modal>
                        {(!this.state.showSamples) ?
                            <div className="d-flex justify-content-center mt-2">
                                <div className={(this.state.disableDate) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={this.onAddSampleItem}>Add Item</div>
                            </div> :
                            <div className="d-flex justify-content-center mt-2">
                                <div className={(this.state.disableDate) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={this.onAddSampleItem}>Save Item</div>
                            </div>
                        }
                    


                        {(this.state.isPharm) ?
                            <div>
                                <h3 className="mt-4">Marketing Intelligence</h3>
                                <div className="row m-1" style={stylesMed.visitTableHeader}>
                                    <div className="col mt-1"></div>
                                    <h6 className="col mt-1" style={stylesMed.reportTableItem}>*Code</h6>
                                    <h6 className="col mt-1" style={stylesMed.reportTableItem}>*Name</h6>
                                    <h6 className="col mt-1" style={stylesMed.reportTableItem}>*Consumption</h6>
                                    <h6 className="col mt-1" style={stylesMed.reportTableItem}>*Trade</h6>
                                    <h6 className="col mt-1" style={stylesMed.reportTableItem}>*Offer</h6>
                                    <h6 className="col mt-1" style={stylesMed.reportTableItem}>*Feedback</h6>
                                </div>
                                {
                                    (this.state.showMarketing) ?
                                        <div>
                                            {this.state.MarketItems.map((item, index, arr) => {
                                                if (index !== arr.length - 1) {
                                                    return (
                                                        <div className="row m-1" key={index} style={stylesMed.visitTableStyle}>
                                                            <div className="col mt-1">
                                                                <div className="btn" style={stylesMed.deleteButton} onClick={() => this.showAlertDeleteMarket(index)}>
                                                                    Delete</div>
                                                            </div>
                                                            <h6 className="col mt-1">{item.code}</h6>
                                                            <h6 className="col mt-1">{item.name}</h6>
                                                            <h6 className="col mt-1">{item.consumption}</h6>
                                                            <h6 className="col mt-1">{item.trade}</h6>
                                                            <h6 className="col mt-1">{item.offer}</h6>
                                                            <h6 className="col mt-1">{item.feedback}</h6>
                                                        </div>
                                                    )
                                                }
                                            })}
                                            <div className="row m-1" style={stylesMed.visitTableStyle}>
                                                <div className="col mt-1"></div>
                                                <input className="col form-control"
                                                    defaultValue={(this.state.loading || this.state.marketProductIndex === -1) ?
                                                        null : this.state.products[this.state.marketProductIndex].default_code}
                                                    onClick={this.showMarketProducts} style={stylesMed.visitMarketInput} />
                                                <p className="col mt-1">{(this.state.loading || this.state.marketProductIndex === -1) ?
                                                    null : this.state.products[this.state.marketProductIndex].name}</p>
                                                <input className="col form-control" type="number"
                                                    onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                                    value={this.state.consumptionInput[this.state.marketIndex]}
                                                    onChange={this.onChangeConsumption} style={stylesMed.visitMarketInput} />
                                                <input className="col form-control" value={this.state.tradeInput[this.state.marketIndex]}
                                                    onChange={this.onChangeTrade} style={stylesMed.visitMarketInput} />
                                                <input className="col form-control" value={this.state.offerInput[this.state.marketIndex]}
                                                    onChange={this.onChangeOffer} style={stylesMed.visitMarketInput} />
                                                <input className="col form-control" value={this.state.feedbackInput[this.state.marketIndex]}
                                                    onChange={this.onChangeFeedbackMark} style={stylesMed.visitMarketInput} />
                                            </div>
                                        </div> :
                                        this.state.MarketItems.map((item, index) => {
                                            return (
                                                <div className="row m-1" key={index} style={stylesMed.visitTableStyle}>
                                                    <div className="col mt-1">
                                                        <div className="btn" style={stylesMed.deleteButton} onClick={() => this.showAlertDeleteMarket(index)}>Delete</div>
                                                    </div>
                                                    <h6 className="col mt-1">{item.code}</h6>
                                                    <h6 className="col mt-1">{item.name}</h6>
                                                    <h6 className="col mt-1">{item.consumption}</h6>
                                                    <h6 className="col mt-1">{item.trade}</h6>
                                                    <h6 className="col mt-1">{item.offer}</h6>
                                                    <h6 className="col mt-1">{item.feedback}</h6>
                                                </div>
                                            )
                                        })
                                }
                                <Modal show={this.state.showMarketProducts} onHide={this.closeMarketProducts} animation={false}>
                                    <Modal.Header>
                                        <Modal.Title>Select Product</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body><div>
                                        <select className="col-sm-6 form-control" value={this.state.marketProductIndex} onChange={this.onSelectMarketProduct}
                                            style={{ width: 300 }}>
                                            <option value=""></option>
                                            {this.state.products.map((item, index) => {
                                                return (
                                                    <option key={index} value={index}>{item.name}</option>
                                                )
                                            })
                                            }
                                        </select>
                                    </div></Modal.Body>
                                </Modal>
                                {(!this.state.showMarketing) ?
                                    <div className="d-flex justify-content-center mt-2">
                                        <div className="btn" style={stylesMed.wideButton} onClick={this.onAddMarketItem}>Add Item</div>
                                    </div> :
                                    <div className="d-flex justify-content-center mt-2">
                                        <div className="btn" style={stylesMed.wideButton} onClick={this.onAddMarketItem}>Save Item</div>
                                    </div>
                                }
                                
                              
                            </div>
                            : null}
                        <Modal show={this.state.showAlertSample} onHide={this.closeAlertDeleteSample} animation={false}>
                            <Modal.Header>
                                <Modal.Title>Are you sure you want to delete this item?</Modal.Title>
                            </Modal.Header>
                            <Modal.Body><div>
                                <div className="btn" style={stylesMed.deleteButtonAlert}
                                    onClick={() => { this.onDeleteSampleItem(this.state.itemIndexSample); this.closeAlertDeleteSample() }}>Delete</div>
                                <div className="btn btn-secondary" style={stylesMed.cancelButtonAlert}
                                    onClick={() => this.closeAlertDeleteSample()}>Cancel</div>
                            </div></Modal.Body>
                        </Modal>
                        <Modal show={this.state.showAlertMarket} onHide={this.closeAlertDeleteMarket} animation={false}>
                            <Modal.Header>
                                <Modal.Title>Are you sure you want to delete this item?</Modal.Title>
                            </Modal.Header>
                            <Modal.Body><div>
                                <div className="btn" style={stylesMed.deleteButtonAlert}
                                    onClick={() => { this.onDeleteMarketItem(this.state.itemIndexMarket); this.closeAlertDeleteMarket() }}>Delete</div>
                                <div className="btn btn-secondary" style={stylesMed.cancelButtonAlert}
                                    onClick={() => this.closeAlertDeleteMarket()}>Cancel</div>
                            </div></Modal.Body>
                        </Modal>
                    </div>
                }
            </div >
        );
    }
}
//export default geolocated({
//    positionOptions: {
//        enableHighAccuracy: false,
//    },
//    userDecisionTimeout: 5000,
//})(AddVisit);